import type React from "react";
import { ReactComponent as Svg } from "./assets/subtract.svg";
import * as styles from "./Icon.module.scss";

type SubtractProps = React.SVGProps<SVGSVGElement>;

export const Subtract = ({ className, ...props }: SubtractProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
